import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=35e0a17c&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&lang=js&"
export * from "./AppIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=35e0a17c&prod&scoped=true&lang=css&"
import style1 from "./AppIcon.vue?vue&type=style&index=1&id=35e0a17c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0a17c",
  null
  
)

export default component.exports